import Navbar from '../components/Navbar';
import Footer from 'components/Footer';
import { useSelector } from "react-redux";
import MobileNavbar from 'components/MobileNavbar';
import MobileFooter from 'components/MobileFooter';

import AlumniAll from 'components/NextconLabAlumni/AlumniAll';

function Alumni() {

  const isMobile = useSelector(state => state.windowSize.isMobile);

  return (
    <>
    {isMobile ? (
      <>
        <MobileNavbar />
        <AlumniAll />
        <MobileFooter />
      </>
    ) : (
      <>
        <Navbar />
        <AlumniAll />
        <Footer />
      </>
    )}
    </>
  );
}

export default Alumni;

/*

  <GradAlumni />
  <hr />
  <PostdocAlumni />
  <hr />
  <UndergradAlumni />

*/